import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import BaseButton from '../button/baseButton'
import LightboxOverlay from '../overlay/LightboxOverlay'

/** Keeps modal above section loaders (z-index 100000). */
const MessageModalRoot = styled(LightboxOverlay)`
  && {
    z-index: 100001;
  }
`

const Panel = styled.div`
  position: relative;
  box-sizing: border-box;
  max-width: 520px;
  width: calc(100vw - 40px);
  padding: 28px 24px 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  font-family: ${theme('typography.paragraph.fontFamily')};
`

const Title = styled.h2`
  margin: 0 0 12px;
  font-family: ${theme('typography.headline.fontFamily')};
  font-size: 18px;
  font-weight: 600;
  line-height: 1.35;
  color: ${theme('colors.primary')};
`

const Body = styled.p`
  margin: 0 0 24px;
  font-family: ${theme('typography.paragraph.fontFamily')};
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  color: #333;
`

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
`

const MessageModal = ({ setClosed, title, body, confirmLabel }) => (
  <MessageModalRoot setClosed={setClosed}>
    <Panel
      role="dialog"
      aria-modal="true"
      aria-labelledby="message-modal-title"
    >
      <Title id="message-modal-title">{title}</Title>
      <Body>{body}</Body>
      <Actions>
        <BaseButton kind="primary" size="small" onClick={setClosed}>
          {confirmLabel}
        </BaseButton>
      </Actions>
    </Panel>
  </MessageModalRoot>
)

MessageModal.propTypes = {
  setClosed: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
}

export default MessageModal
